import React from "react";

import {Types} from "components";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import SignatureCanvas from "react-signature-canvas";
import {Button} from "reactstrap";
import moment from "moment";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Dispositions_Pendings_Object} state
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */
export default class EmployeeSign extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
	}

	/** @type Object */
	sigPad35 = null;
	clear = (sigPad) => () => {
		this[sigPad].clear();
	};

	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		this.state.signature_35 = this.sigPad35.getCanvas().toDataURL('image/png');
		this.state.signature_35_date = moment().local().format('YYYY-MM-DD HH:mm:ss');
		return true;
	}
88
	async handleSubmit() {
		if (this.sigPad35.isEmpty()) {
			this.setState({invalidSignature: true})
		} else {
			this.handleProcess(null, null);
			this.props.afterSave({
				signature_35: this.state.signature_35,
				signature_35_date: this.state.signature_35_date,
			})
		}
	}

	form = () => {
		return (
			<div>
				<p style={{textAlign: 'center'}}>
					<b>I certify that: (1) I have read and understand the Notices, Instructions, and Definitions on this ATF Form 4473; (2) the
						information recorded in Sections A, C and E
						is true, correct, and complete; and (3) this entire transaction record has been completed at the licensed business premises
						(“licensed premises” includes business
						temporarily conducted from a qualifying gun show or event in the same State in which the licensed premises is located) unless
						this transaction has met the
						requirements of 18 U.S.C. 922(c). Unless this transaction has been denied or cancelled by NICS or State agency, I further
						certify on the basis of — (1) the
						transferee’s/buyer’s responses in Section B (and Section D, if applicable); (2) the verification of the identification
						recorded in question 26 (and the re-verification at
						the time of transfer, if Section D was completed); and (3) State or local law applicable to the firearms business — it is my
						belief that it is not unlawful for me to sell,
						deliver, transport, or otherwise dispose of the firearm(s) listed on this form to the person identified in Section B. </b>
				</p>
				<div className={'row'} style={{justifyContent: "center"}}>
					<div style={{textAlign: 'center'}}>
						<Card>
							{this.state.invalidSignature &&
								<div className={'row'}>
									<div className={'col errorColor pl-3'} style={{marginTop: '-10px', marginBottom: '10px'}}>
										<em>Signature is required</em>
									</div>
								</div>
							}
							<CardContent style={{position: "relative"}}>
								<span className={'signature'}/>
								<div style={{backgroundColor: '#f2f3f4'}}>
									<SignatureCanvas penColor='black' canvasProps={{width: 675, height: 208, className: 'sigCanvas'}} minWidth={3}
									                 ref={ref => this.sigPad35 = ref}/>
								</div>
							</CardContent>
							<CardActions style={{paddingTop: 0}}>
								<Button color="secondary" onClick={this.clear('sigPad35')}>Clear</Button>
							</CardActions>
						</Card>
					</div>
				</div>
			</div>
		)
	};

}

